import DataTable from 'react-data-table-component';
import React from 'react'

// import Editjournals from './editjournals';
import Actionjourparta from './actionjourparta';


const columns = [
    {
        name: 'TDS code',
        width: '120px',
        sortable: true,
        selector: row => row.tdscode,
    },
    {
        name: 'Rr.',
        width: '50px',
        selector: row => row.revision,
    },
    {
        name: 'createdate',
        width: '120px',
        selector: row => row.createdate,
    },
    {
        name: 'Journal Type / Customer',
        width: '300px',
        cell: row => (
            <div>
                <div style={{ fontWeight: 'bold', fontSize: 12 }}>{row.journaltype}</div>
                <div style={{ color: '#555', fontSize: 11 }}>{row.customername}</div>
            </div>
        ),
    },
    {
        name: 'itemname',
        selector: row => row.itemname,
    },
    {
        name: 'Action',
        width: '250px',
        cell: row =><Actionjourparta id={row.journalId}/>,
    },

];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};



const Journaltable = (datatable) => {
    var dataresult = datatable.datatable;
  

    return (
    
        <DataTable
            columns={columns}
            data={dataresult}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )
}

export default Journaltable